import { type FC } from 'react';
import { IconButton } from '@chakra-ui/react';
import { ReactComponent as MenuIcon } from '../assets/svg/Menu.svg';
import { translate } from '../constants/translation';

interface Props {
  toggleTripsPanel: () => void;
}

const TripsHistoryToggle: FC<Props> = ({ toggleTripsPanel }) => {
  return (
    <IconButton
      variant="secondary"
      className="trips-history-toggle"
      onClick={toggleTripsPanel}
      icon={<MenuIcon />}
      aria-label={translate('TRIPS_HISTORY_TOGGLE')}
    />
  );
};

export default TripsHistoryToggle;
